import { LoginResponse } from '@/api/types';
import config from '@/config';
import http from '@/api/http';

export default async (studentId: string): Promise<LoginResponse> => {
    const endpoint = `${config.apiUrl}/student-login`;
    const { data } = await http.post(endpoint, { studentId });
    console.log('studentLogin data: ', data);
    return data;
};
